export async function deltaHandlerSelectTask(taskId:ID, requiredParams: any = {id: true}) {
    const tasks = await selectTasks([taskId], requiredParams)
    return tasks ? tasks[0] : undefined
}

export async function selectTasks(taskIds: ID[], requiredParams: any = {id: true}): Promise<any[]> {
    return await gd.api.Task.select(taskIds, requiredParams).promise()
}